import { NOTIFICATIONS_TAB_HELPER_TEXT } from "../../../../../../utils/planManager/planConfigurationUtils.js";
import EventsTable from "./EventsTable";
import "./NotificationsTab.scss";

/**
 * Notifications tab — helper text, submit action, warning alert, and events table.
 *
 * @param {object} props
 * @returns {import('react').JSX.Element}
 */
const NotificationsTab = ({
    selectedCommsLibraryTitle,
    selectedLanguage,
    events,
    showEventsOffWarning,
    isSubmitDisabled,
    onSubmit,
    onEventToggle,
    onEoyChange,
}) => (
    <div id="panel-notifications" role="tabpanel" aria-labelledby="tab-notifications">
        <div className="plan-notification-notifications-action">
            <p className="plan-notification-tab-helper">
                {NOTIFICATIONS_TAB_HELPER_TEXT}
            </p>
            <button
                type="button"
                className="plan-notification-notifications-action__submit"
                disabled={isSubmitDisabled}
                onClick={onSubmit}
            >
                Submit
            </button>
        </div>

        <h2 className="plan-notification-notifications-title">
            {selectedCommsLibraryTitle
                ? `${selectedCommsLibraryTitle} Notifications`
                : "Notifications"}
        </h2>

        {showEventsOffWarning ? (
            <div className="plan-notification-alert plan-notification-alert--warning" role="alert">
                <strong>Warning</strong>
                <p>
                    There is a fee to turn off any standard communications. Please
                    notify the member communications team if a client is requesting
                    that notifications be switched off.
                </p>
            </div>
        ) : null}

        <EventsTable
            events={events}
            selectedLanguage={selectedLanguage}
            onEventToggle={onEventToggle}
            onEoyChange={onEoyChange}
        />
    </div>
);

export default NotificationsTab;
